
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gP1C5a4Vws_yd9QTtaYnY45GW0RuvlP1X_45RQrhJe2aYMMeta } from "/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index_45beFPV4JabLWh_459lAnhYb27u0xDtviDXCbGz_o4TnjkMeta } from "/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchAF1zL8Lj1Bf_45J_xvnmfNeUdhgfszDkALO0FEo1ngzmwMeta } from "/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexYAF3eEUzUTgTTKQv66nEzO9Qplcr7THoc4P5zHv3djwMeta } from "/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Ww5ANF9fiFsjGev7p_QjV3hO5uxrPH5yxwf6PLVJ5MoMeta } from "/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index0RaLnMaerXjAmnTegluDjs7JLwyHiLlBocXrHdt97EEMeta } from "/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_9386FqTLUo2mZbbg8UoO5ZTxhE59leOeqDaknyQsKBTBIMeta } from "/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexWHk8l37PrdYIuhehwzCTHvogE_45IB8A0CrgnXZL_eAPwMeta } from "/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93AmgVQixJF6QixvsytVZyMwYrhZ1SBNO_453fQQiBxR_45PoMeta } from "/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexl5DdMqWO_RNzLCBkObS2pmYcMVlweWVUbQh1_Wh4s2UMeta } from "/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexwrvgMN0jtGKpafL3nZC57xO7FSyM4EVPiKV4YemfyAoMeta } from "/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index0RaLnMaerXjAmnTegluDjs7JLwyHiLlBocXrHdt97EEMeta || {},
    component: () => import("/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexWHk8l37PrdYIuhehwzCTHvogE_45IB8A0CrgnXZL_eAPwMeta || {},
    component: () => import("/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexl5DdMqWO_RNzLCBkObS2pmYcMVlweWVUbQh1_Wh4s2UMeta || {},
    component: () => import("/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexwrvgMN0jtGKpafL3nZC57xO7FSyM4EVPiKV4YemfyAoMeta || {},
    component: () => import("/codebuild/output/src1695492781/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]